import React, { Component } from 'react';
import {Col, Container, Row, Stack} from "react-bootstrap";
import { ReactComponent as Arrow } from "../assets/Arrow Left.svg";


class FormSupportQualityFeedbackSelection extends Component {


    render() {
        return (
            <Container fluid className="d-flex flex-column Form-body Peach mt-3">
                <Row style={{width: "fit-content"}} className="col-sm d-block d-sm-none">
                    <button  className="prev-button" onClick={() => {this.props.prevStep(2)}}><Arrow/> &nbsp; Back</button>
                </Row>
                <Row>
                    <Col>
                        <Stack className="top-row" direction="horizontal" gap={2}>
                            <div className="indicator Active"></div>
                            <div className="indicator Active"></div>
                            <div className="indicator Active"></div>
                            <div className="indicator"></div>
                        </Stack>
                    </Col>
                </Row>
                <Row className="flex-grow-1 align-items-center middle-row">
                    <Col xs={12} lg = {6} className="align-items-start">
                        <p className="text">Please clarify what caused the negative experience</p>
                    </Col>
                    <Col className="align-items-center" xs={12} lg = {6}>
                        <Stack className="align-items-end">
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.supportDisappointmentReason === "inappropriate tone" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("supportDisappointmentReason", "inappropriate tone")
                                }}>
                                Inappropriate tone
                            </button>
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.supportDisappointmentReason === "generic response" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("supportDisappointmentReason", "generic response")
                                }}>
                                Generic response
                            </button>
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.supportDisappointmentReason === "confusing response" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("supportDisappointmentReason", "confusing response")
                                }}>
                                Confusing response
                            </button>
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.supportDisappointmentReason === "too long conversation" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("supportDisappointmentReason", "too long conversation")
                                }}>
                                Too long conversation
                            </button>
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.supportDisappointmentReason === "other" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("supportDisappointmentReason", "other")
                                    // this.props.handleTextChange("disappointmentComment", "")
                                }}>
                                Other
                            </button>
                        </Stack>
                    </Col>
                </Row>
                <Row className="bottom-row align-items-center">
                    <Col className="col-sm d-none d-sm-block">
                        <button className="prev-button" onClick={() => {
                            this.props.prevStep(2)
                        }}>&lt; Previous Question
                        </button>
                    </Col>
                    <Col className="text-end">
                        {
                            this.props.inputValues.supportDisappointmentReason === "" ?
                                <button className="next-button feedback disabled" disabled onClick={() => {
                                }}>Next
                                </button>:
                                <button className="next-button feedback" onClick={() => {
                                    {this.props.inputValues.supportDisappointmentReason === "other" ?
                                            this.props.nextStep(3):
                                            this.props.onSubmit(true)}
                                }}>Next
                                </button>}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default FormSupportQualityFeedbackSelection;